module.exports = __webpack_public_path__ + "img/chatxc-app-icon.99f4a612.png";